import { FC, useMemo } from 'react';

import SettingsTitle from '@views/admin/components/SettingsTitle';

import AppView from '@components/layout/AppView';
import RouterTabs from '@components/layout/Tabs/RouterTabs';
import { useRouteMatch } from '@components/router';

import SparkSnapsDashboardView from './SparkSnapsDashboardView';
import SparkSnapTemplatesView from './SparkSnapsTemplatesView/SparkSnapsTemplatesView';

import './AdminAccountSnapsView.scss';

interface AdminAccountSnapsViewProps {}

const AdminAccountSnapsView: FC<AdminAccountSnapsViewProps> = () => {
    const { path } = useRouteMatch();
    const routes = useMemo(() => {
        return [
            {
                url: `${path}`,
                text: 'All Snaps',
                to: `${path}`,
            },
            {
                url: `${path}/templates`,
                text: 'Templates',
                to: `${path}/templates`,
            },
        ];
    }, [path]);

    return (
        <AppView.Content title={<SettingsTitle label="Snaps" />} className="admin-snaps-view">
            <RouterTabs color="blue" tabs={routes}>
                <RouterTabs.Tab path={`${path}`}>
                    <SparkSnapsDashboardView />
                </RouterTabs.Tab>
                <RouterTabs.Tab path={`${path}/templates`}>
                    <SparkSnapTemplatesView />
                </RouterTabs.Tab>
            </RouterTabs>
        </AppView.Content>
    );
};

export default AdminAccountSnapsView;
